import { MockMethod } from 'vite-plugin-mock';
import { resultError, resultSuccess, getRequestToken, requestParams } from '../_util';

export function createFakeUserList() {
  return [
    // {
    //   userId: '102674',
    //   username: 'admin',
    //   realName: '超级管理员',
    //   avatar: 'https://test-cdn.ciicbj.cn/public/cloud_logo_1.png',
    //   desc: 'manager',
    //   password: 'Ciic202203211926',
    //   token: 'fakeToken1',
    //   homePath: '/socialSecurity/archives',
    //   roles: [
    //     {
    //       roleName: 'Super Admin',
    //       value: 'super',
    //     },
    //   ],
    // },
    // {
    //   userId: '3bf81c97820d4c5284e770aed3d8e6a7',
    //   username: 'test',
    //   password: 'Ciic202203211926',
    //   realName: 'test user',
    //   avatar: 'https://test-cdn.ciicbj.cn/public/cloud_logo_1.png',
    //   desc: 'tester',
    //   token: 'fakeToken2',
    //   homePath:'/dashboard/workbench',
    //   roles: [
    //     {
    //       roleName: 'Tester',
    //       value: 'test',
    //     },
    //   ],
    // },
  ];
}

const fakeCodeList: any = {
  '1': ['1000', '3000', '5000'],

  '2': ['2000', '4000', '6000'],
};
export default [
  // mock user login
  {
    url: '/basic-api/login',
    timeout: 200,
    method: 'post',
    response: ({ body }) => {
      const { username, password } = body;
      const checkUser = createFakeUserList().find(
        (item) => item.username === username && password === item.password,
      );
      if (!checkUser) {
        return resultError('Incorrect account or password！');
      }
      const { userId, username: _username, token, realName, desc, roles } = checkUser;
      return resultSuccess({
        roles,
        userId,
        username: _username,
        token,
        realName,
        desc,
      });
    },
  },
  {
    url: '/basic-api/getUserInfo',
    method: 'get',
    response: (request: requestParams) => {
      const token = getRequestToken(request);
      if (!token) return resultError('Invalid token');
      const checkUser = createFakeUserList().find((item) => item.token === token);
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!');
      }
      return resultSuccess(checkUser);
    },
  },
  {
    url: '/basic-api/getPermCode',
    timeout: 200,
    method: 'get',
    response: (request: requestParams) => {
      const token = getRequestToken(request);
      if (!token) return resultError('Invalid token');
      const checkUser = createFakeUserList().find((item) => item.token === token);
      if (!checkUser) {
        return resultError('Invalid token!');
      }
      const codeList = fakeCodeList[checkUser.userId];

      return resultSuccess(codeList);
    },
  },
  {
    url: '/basic-api/logout',
    timeout: 200,
    method: 'get',
    response: (request: requestParams) => {
      const token = getRequestToken(request);
      if (!token) return resultError('Invalid token');
      const checkUser = createFakeUserList().find((item) => item.token === token);
      if (!checkUser) {
        return resultError('Invalid token!');
      }
      return resultSuccess(undefined, { message: 'Token has been destroyed' });
    },
  },
] as MockMethod[];
